<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
<speed-dial-fab class="speed-dial-container" [ngClass]="speedDialFabPosition" [reverse-column-direction]="speedDialFabPosition===SpeedDialFabPosition.Bottom" (fabClick)="onSpeedDialFabClicked($event)" [buttons]="speedDialFabButtons"></speed-dial-fab>
